/**
 * Narrow reads retain cached rows, so track pending uploads until a member
 * upload row replaces them in the same cache write. Each placeholder learns
 * its document when the upload creates it: uploads land in any order, and a
 * row may only replace the placeholder for its own document.
 */
const pendingUploads = new Map<string, Map<string, string | undefined>>();

export const trackPendingUpload = (issueId: string, eventId: string): void => {
  const placeholders = pendingUploads.get(issueId) ?? new Map();
  placeholders.set(eventId, undefined);
  pendingUploads.set(issueId, placeholders);
};

export const attachPendingUploadDocument = (
  issueId: string,
  eventId: string,
  documentId: string,
): void => {
  const placeholders = pendingUploads.get(issueId);
  if (placeholders?.has(eventId)) {
    placeholders.set(eventId, documentId);
  }
};

export const forgetPendingUpload = (issueId: string, eventId: string): void => {
  pendingUploads.get(issueId)?.delete(eventId);
};

/** Placeholder event id to the document its upload created, once known. */
export const pendingUploadsFor = (
  issueId: string,
): ReadonlyMap<string, string | undefined> =>
  pendingUploads.get(issueId) ?? new Map();
